import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import {getIsDefaultRegion} from '../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import NewPurchaseCreditModal from './NewPurchaseCreditModal'
import NewPurchaseCreditModalV2 from './NewPurchaseCreditModalV2'

const NewPurchaseCreditModalWrapper: FC = () => {
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  return <>{isDefaultRegion ? <NewPurchaseCreditModalV2 /> : <NewPurchaseCreditModal />}</>
}

export {NewPurchaseCreditModalWrapper}
